import ReactMarkdown from 'react-markdown';
import breaks from 'remark-breaks';

const allowedElements = ['p', 'strong', 'em', 'ul', 'ol', 'li', 'a', 'br'];
const allowedProtocol = /^(https?:|mailto:)/i;

// Texts are authored by admins but shown to every role, so raw HTML is never rendered
// and only http(s)/mailto links are kept.
const transformLinkUri = (uri: string) => (allowedProtocol.test(uri) ? uri : '');

interface FormattedTextProps {
  text?: string;
  paragraphClassName?: string;
}

export default function FormattedText({ text, paragraphClassName }: FormattedTextProps) {
  if (!text) return null;

  return (
    <ReactMarkdown
      className="space-y-2"
      remarkPlugins={[breaks]}
      allowedElements={allowedElements}
      unwrapDisallowed
      linkTarget="_blank"
      transformLinkUri={transformLinkUri}
      components={{
        p: ({ node, ...props }) => <p {...props} className={paragraphClassName} />,
        a: ({ node, children, ...props }) => <a {...props} rel="noopener noreferrer" className="underline">{children}</a>,
        ul: ({ node, ordered, ...props }) => <ul {...props} className="list-disc ml-6" />,
        ol: ({ node, ordered, ...props }) => <ol {...props} className="list-decimal ml-6" />,
      }}
    >
      {text}
    </ReactMarkdown>
  );
}
